const bs = {
	CardsHeader: 'Naše specijalizacije',
	CardsTitleAutografika: 'Autografika',
	CardsTitleForeksPleksi: 'Foreks / Pleksi',
	CardsTitlePVC: 'PVC naljepnice',
	CardsTitleCerade: 'Cerade',
	OffersHeader: 'Mi Vam nudimo',
	OfferTitleKonsultacija: 'Konsultacije',
	OfferTitleDizajn: 'Dizajn / Priprema',
	OfferTitleStampa: 'Štampa',
	OfferTitleMontaza: 'MontaŽa',
	ServiceTitleAutografika: 'Autografika',
	SerivceDescriptionAutografika: 'Autografika je jedna od najefikasnijih mobilnih načina oglašavanja. Iskoritite da vaš proizvod svi primjete. Štampa na kvalitetnim Polymernim folijama koje prilikom skidanja ne ostavlja nikakve tragove ljepila na autu. Njena velika prednost jeste da će također lak vašeg vozila ostati zaštićen.',
	ServiceTitlePromo: 'Promo materijali',
	ServiceDescriptionPromo: 'Reklama i poklon, najbolja kombinacija kreiranja dobrog imidža Vaše kompanije. U ponudi imamo razne arkao što su; šolje, auto termos šoljica, upaljači, puzzle, podloge za miš, majice i mnoštvo drugih. Svi artikli su sa full color štampom.',
	ServiceTitleForeksPleksi: 'Foreks / Pleksi',
	SerivceDescriptionForeksPleksi: 'Razni promotivni materijali izrađeni od foreksa i pleksiglas materijala.',
	ServiceTitlePVC: 'PVC naljepnice',
	SerivceDescriptionPVC: 'Izrada vrlo kvalitetnih i dugotrajnih PVC naljepnica koje su otporne na toplotu i vodu. Nudimo vam veliki asortiman materijala od PVC samoljepljivih folija (mat ili gloss), prozorske šupljikave folije, pjeskarene folije, folije za izrezivanje, podna grafika, itd.',
	ServiceTitleCerade: 'Cerade',
	ServiceDescriptionCerade: 'Cerade su jedna od najjeftinijih, ali najučinkovitijih materijala, koja služe za oglašavanje. Jako su otporne na vremenske uslove poput vjetra i UV - zraka. Jedna od prednosti ovog materijala jeste mogućnost premiještanja vizuala po potrebi, idealno za sajmove, događaje ili promocije.',
	ServiceTitleSvijetlece: 'Svijetleće reklame',
	ServiceDescriptionSvijetlece: 'Izuzetno efikasan način oglašavanja danju i noću.Vršimo izradu 3D LED blok slova, AluBond boksova ili LED panela.Ono što zasigurno privlači najveću pažnju noću jesu upravo svijetleće reklame. Bilo da su postavljene uz cestu ili na Vaš objekat',
	ServiceTitleProzorska: 'Prozorska grafika',
	ServiceDescriptionProzorska: 'One-way vision ili prozorska grafika samoljepljivi je PVC materijal specijalno izrađen za aplikacije na prozorima. Omogućava prodor svjetlosti, a vizuelna je barijera spoljašnjem okruženju. Šta znaći da se sa spoljašnje strane stakla vidi aplikacija, a sa unutrašnje strane staklo je blago zatamljeno.',
	GalleryHeader: 'Galerija',
	GalleryTitleSvijetlece: 'Svijetleće reklame',
	GalleryTitleRazno: 'Razno',
	GalleryPointerSlike: 'Slike',
	ContactTelephone: 'Telefon',
	ContactAddress: 'Adresa',
	ContactEmail: 'E-mail',
	MenuLinkHome: 'Početna',
	MenuLinkServices: 'Usluge',
	MenuLinkGallery: 'Galerija',
	MenuLinkReferences: 'Reference',
	MenuLinkContact: 'Kontakt'
}

const de = {
	CardsHeader: 'Unsere Spezialisierung',
	CardsTitleAutografika: 'Autografik',
	CardsTitleForeksPleksi: 'Forex / Plexi ',
	CardsTitlePVC: 'PVC Aufkleber',
	CardsTitleCerade: 'Planen',
	OffersHeader: 'Wir bieten folgendes an',
	OfferTitleKonsultacija: 'Konsultationen',
	OfferTitleDizajn: 'Design',
	OfferTitleStampa: 'Druck',
	OfferTitleMontaza: 'Montage',
	ServiceTitleAutografika: 'Autografik',
	SerivceDescriptionAutografika: 'Autografik ist eine der effektivsten mobilen Werbemethoden. Stellen Sie sicher, dass Ihr Produkt bemerkt wird. Bedruckt auf hochwertige Polymerfolien, die beim Entfernen keine Klebstoffrückstände auf dem Fahrzeug hinterlassen. Ihr großer Vorteil ist, dass auch Ihr Fahrzeuglack geschützt bleibt.',
	ServiceTitlePromo: 'Werbematerialien',
	ServiceDescriptionPromo: 'Werbung und Geschenk, die beste Kombination für die Reputation Ihres Unternehmens. Wir bieten verschiedene Artikel in unserem Angebot an wie z.b. Tassen, Thermoskannen, Feuerzeuge, Puzzle, Mauspads, T-Shirts und viele andere. Alle Artikel sind Vollfarbdruck',
	ServiceTitleForeksPleksi: 'Forex / Plexi',
	SerivceDescriptionForeksPleksi: 'Verschiedene Werbematerialien aus Forex und Plexiglas.',
	ServiceTitlePVC: 'PVC Aufkleber',
	SerivceDescriptionPVC: 'Herstellung von hochwertigen und langlebigen PVC-Aufkleber, die hitze- und wasserfest sind. Wir bieten eine breite Palette an Materialien an: PVC-Selbstklebefolien (matt oder glänzend), Fensterfolien, Milchglass Folien, Ausschnittfolien, Bodengrafiken usw.',
	ServiceTitleCerade: 'Planen',
	ServiceDescriptionCerade: 'Planen gehören zu den billigsten, aber effektivsten Werbematerialien. Sie sind sehr widerstandsfähig gegen Witterungseinflüsse wie Wind und UV Strahlen. Ideal für Messen, Veranstaltungen oder Werbeaktionen.',
	ServiceTitleSvijetlece: 'Leuchtreklamen',
	ServiceDescriptionSvijetlece: 'Äußerst effiziente Art der Werbung für Tag und Nacht: Wir erstellen 3D-LED-Buchstabenblöcke, AluBond-Boxen oder LED-Panels, und bei Nacht ist die hellste Werbung genau das Richtige. Ob sie an der Straße oder an Ihrem Gebäude montiert sind.',
	ServiceTitleProzorska: 'One Way Vision Folie',
	ServiceDescriptionProzorska: 'One Way Vision Folien sind ein selbstklebendes PVC-Material, das speziell für Fensteranwendungen entwickelt wurde. Es bietet Lichteinfall und Sichtschutz für die Außenumgebung. Das bedeutet, dass die Anwendung von außen sichtbar ist und das Glas von innen etwas dunkler wird.',
	GalleryHeader: 'Galerie',
	GalleryTitleSvijetlece: 'Leuchtreklamen',
	GalleryTitleRazno: 'Diverses',
	GalleryPointerSlike: 'Bilder',
	ContactTelephone: 'Telefon',
	ContactAddress: 'Adrese',
	ContactEmail: 'E-mail',
	MenuLinkHome: 'Startseite',
	MenuLinkServices: 'Dienstleistungen',
	MenuLinkGallery: 'Galerie',
	MenuLinkReferences: 'Referenzen',
	MenuLinkContact: 'Kontakt'
}

export default {
	bs,
	de
}